export class BusinessTripEventRemoteActionType {
  static readonly START_OF_STEERING_PAUSE =
    new BusinessTripEventRemoteActionType(
      'startofsteeringpause',
      'BUSINESSTRIP-EVENT-REMOTEACTION.SOSP.PAGE-TITLE',
      'BUSINESSTRIP-EVENT-REMOTEACTION.SOSP.DESCRIPTION',
      'BUSINESSTRIP-EVENT-REMOTEACTION.SOSP.TITLE',
      'BUSINESSTRIP-EVENT-REMOTEACTION.SOSP.RA.LABEL.SHORT',
      'BUSINESSTRIP-EVENT-REMOTEACTION.SOSP.RA.LABEL.LONG'
    );
  static readonly END_OF_STEERING_PAUSE = new BusinessTripEventRemoteActionType(
    'endofsteeringpause',
    'BUSINESSTRIP-EVENT-REMOTEACTION.EOSP.PAGE-TITLE',
    'BUSINESSTRIP-EVENT-REMOTEACTION.EOSP.DESCRIPTION',
    'BUSINESSTRIP-EVENT-REMOTEACTION.EOSP.TITLE',
    'BUSINESSTRIP-EVENT-REMOTEACTION.EOSP.RA.LABEL.SHORT',
    'BUSINESSTRIP-EVENT-REMOTEACTION.EOSP.RA.LABEL.LONG'
  );
  static readonly START_OF_RESTING_PAUSE =
    new BusinessTripEventRemoteActionType(
      'startofrestingpause',
      'BUSINESSTRIP-EVENT-REMOTEACTION.SORP.PAGE-TITLE',
      'BUSINESSTRIP-EVENT-REMOTEACTION.SORP.DESCRIPTION',
      'BUSINESSTRIP-EVENT-REMOTEACTION.SORP.TITLE',
      'BUSINESSTRIP-EVENT-REMOTEACTION.SORP.RA.LABEL.SHORT',
      'BUSINESSTRIP-EVENT-REMOTEACTION.SORP.RA.LABEL.LONG'
    );
  static readonly END_OF_RESTING_PAUSE = new BusinessTripEventRemoteActionType(
    'endofrestingpause',
    'BUSINESSTRIP-EVENT-REMOTEACTION.EORP.PAGE-TITLE',
    'BUSINESSTRIP-EVENT-REMOTEACTION.EORP.DESCRIPTION',
    'BUSINESSTRIP-EVENT-REMOTEACTION.EORP.TITLE',
    'BUSINESSTRIP-EVENT-REMOTEACTION.EORP.RA.LABEL.SHORT',
    'BUSINESSTRIP-EVENT-REMOTEACTION.EORP.RA.LABEL.LONG'
  );

  // private to disallow creating other instances of this type
  private constructor(
    public readonly endpoint: string,
    public readonly pageTitle: string,
    public readonly descriptionKey: string,
    public readonly titleKey: string,
    public readonly raShortLabel: string,
    public readonly raLongLabel: string
  ) {}

  toString() {
    return this.endpoint;
  }
}
